import React, { useState } from "react";
import { DynamicField } from "../../../components/ui/DynamicField";
import { WarmUpSectionInput } from "../../../config/allWorkout";
import UploadedBanner from "../../../components/common/UploadBanner";
import { useMediaStore } from "../../../store";

const WarnUp = ({
  exercise = {},
  warmUpCategory,
  disabled,
  setSelectedVideoUrl,
  setSelectedImageUrl,
}) => {
  const { imageUrls, videoUrls } = useMediaStore();
  const [formData, setFormData] = useState(exercise || {});

  const handleFieldChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleSelectChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    if (key === "video_url") {
      setSelectedVideoUrl(value);
    } else if (key === "image_url") {
      setSelectedImageUrl(value);
    }
  };


  return (
    <div className="row">
      <div className="col-sm-8">
        <div className="row mb-3" key={exercise.id}>
          <div className="row separator">
            <div className="col-sm-12">
              <div className="mb-3">
                <DynamicField
                  label="Sub-category"
                  type="text"
                  placeholder="Sub-category"
                  value={warmUpCategory || ""}
                  onChange={(e) =>
                    handleFieldChange("warmUpCategory", e.target.value)
                  }
                  disabled={disabled}
                />
              </div>
            </div>

            {WarmUpSectionInput.map((fieldConfig, index) => (
              <div className="col-sm-6 mb-3" key={index}>
                {fieldConfig.valueKey === "video_url" ||
                fieldConfig.valueKey === "image_url" ? (
                  <div className="mb-3">
                    <label
                      htmlFor={fieldConfig.valueKey}
                      className="form-label fw-medium fs"
                    >
                      {fieldConfig.label}
                    </label>
                    <select
                      className="form-select"
                      id={fieldConfig.valueKey}
                      value={formData[fieldConfig.valueKey] || ""}
                      onChange={(e) =>
                        handleSelectChange(fieldConfig.valueKey, e.target.value)
                      }
                      disabled={!disabled}
                    >

                      <option value="">Select {fieldConfig.label}</option>
                      {fieldConfig.valueKey === "image_url" && imageUrls.map(
                        (url, index) => (
                          <option key={index} value={url.value}>
                            {url.label}
                          </option>
                        )
                      )}
                       {fieldConfig.valueKey === "video_url" && videoUrls.map(
                        (url, index) => (
                          <option key={index} value={url.value}>
                            {url.label}
                          </option>
                        )
                      )}

                      {/* {dummyUrls[fieldConfig.valueKey.replace("_url", "s")].map(
                        (url, index) => (
                          <option key={index} value={url}>
                            {url}
                          </option>
                        )
                      )} */}
                    </select>

                    <div className="mt-2">
                      <label className="form-label">
                        Selected {fieldConfig.label}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData[fieldConfig.valueKey] || ""}
                        onChange={(e) =>
                          handleFieldChange(
                            fieldConfig.valueKey,
                            e.target.value
                          )
                        }
                        placeholder="Selected URL will appear here"
                        disabled={!disabled}
                      />
                    </div>
                  </div>
                ) : (
                  <DynamicField
                    label={fieldConfig.label}
                    type={fieldConfig.type}
                    value={formData[fieldConfig.valueKey] || ""}
                    placeholder={fieldConfig.placeholder}
                    options={fieldConfig.options}
                    defaultValue={fieldConfig.defaultValue}
                    onChange={(e) =>
                      handleFieldChange(fieldConfig.valueKey, e.target.value)
                    }
                    disabled={disabled}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="col-sm-4">
        <UploadedBanner defaultImage={formData.image_url} />
      </div>
    </div>
  );
};

export default WarnUp;
